export const isTimeValid = (scheduleOptions, value) => {
  return scheduleOptions.includes(value) ? value : "";
};
